import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import { UserOutlined } from '@ant-design/icons';
import styles from '../styles/advanceSummaryCard.module.scss';

function AdvanceSummaryCardHeader({ userName, avatarUrl }) {
    return (
        <div className={styles.header}>
            <div className={styles.headerAvatar}>
                {avatarUrl ? (
                    <img src={avatarUrl} alt={userName} className={styles.headerAvatarImg} />
                ) : (
                    <UserOutlined style={{ fontSize: 32 }} />
                )}
            </div>
            <Text as="span" size="m" className={styles.headerTitle}>
                {`${userName}\u2019s Advance Summary`}
            </Text>
        </div>
    );
}

export default AdvanceSummaryCardHeader;
